import { config } from '@/config/env'
import type { Catalog } from './types'
import { CatalogError, parseCatalog } from './validate'

let pending: Promise<Catalog> | null = null

async function fetchCatalog(): Promise<Catalog> {
  if (config.catalogUrl === 'demo') {
    // Split into its own chunk; never downloaded unless explicitly enabled.
    const demo = await import('./fixtures/demo-catalog.json')
    return parseCatalog(demo.default)
  }

  const response = await fetch(config.catalogUrl, { headers: { Accept: 'application/json' } })
  if (!response.ok) throw new CatalogError(`Catalog request failed with status ${response.status}`)
  return parseCatalog(await response.json())
}

/**
 * Loads the catalog once per page session. A failed load is not cached, so a
 * retry (e.g. from an error screen) performs a fresh request.
 */
export function loadCatalog(): Promise<Catalog> {
  pending ??= fetchCatalog().catch((error: unknown) => {
    pending = null
    throw error
  })
  return pending
}

export const isDemoCatalog = config.catalogUrl === 'demo'
